import { useAppSelector } from "../redux/store";

/**
 * Hook to access menu-related state from Redux store
 * Extracts player details, auth loading state, and meta state (loading, error)
 */
export function useMenuState() {
  const playerDetails = useAppSelector((state) => state.menu.playerDetails);
  const authLoading = useAppSelector((state) => state.menu.authLoading);
  const metaState = useAppSelector((state) => state.meta);

  return {
    playerDetails,
    authLoading,
    loading: metaState.loading,
    error: metaState.error,
  };
}
